import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialMovementService = {
    getById: async (id) => axios.get(`${API_URL}/material-movements/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getByUser: async (id) => axios.get(`${API_URL}/material-movements/caution/requester/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getByUserAndStorage: async (userId, storageId) => axios.get(`${API_URL}/material-movements/caution/requester/${userId}/${storageId}`).then(({data}) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(`${API_URL}/material-movements/caution`, data).then(({data}) => data).catch((err) => { throw err }),
    saveDevolution: async (formData) => axios.post(`${API_URL}/material-movements/devolution`, formData).then(({data}) => data).catch((err) => { throw err }),
    saveDecrease: async (formData) => axios.post(`${API_URL}/material-movements/decrease`, formData).then(({data}) => data).catch((err) => { throw err }),
}

export default MaterialMovementService;